"use strict";

exports.__esModule = true;
exports["default"] = ArrowLeft;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "-229.5 -44 120 120",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-166.803 58.418c3.09 3.104 3.09 8.128 0 11.18a7.718 7.718 0 0 1-5.59 2.366 7.779 7.779 0 0 1-5.589-2.366l-48.201-48.148c-.683-.729-1.282-1.598-1.663-2.544-.415-.994-.638-2.003-.638-3.065a7.46 7.46 0 0 1 .638-3.018c.381-.996.98-1.851 1.663-2.57l47.938-47.893a7.887 7.887 0 0 1 11.179 0 7.89 7.89 0 0 1 0 11.173l-34.417 34.381h83.036c4.373 0 7.933 3.561 7.933 7.92 0 4.371-3.561 7.911-7.933 7.911h-83.036l34.68 34.673z"
  }));
}